"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var S = _interopRequireWildcard(require("./wsLimitReachedStyle"));
var _crossIcon = _interopRequireDefault(require("./cross-icon.svg"));
var _wsIllustration = _interopRequireDefault(require("./ws-illustration.svg"));
var _greenTick = _interopRequireDefault(require("./green-tick.svg"));
var _events = _interopRequireDefault(require("printableWorksheets/events"));
var _common = require("apps/teacher/config/common");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var WSLimitReachedPopup = function WSLimitReachedPopup(props) {
  (0, _react.useEffect)(function () {
    var eventProps = {
      from: 'Close',
      freeWorksheetsLeftCount: (0, _common.freeWsDownloadLeft)(),
      contentType: 'Worksheets'
    };
    _events["default"].viewedSubscribePopup(eventProps);
  }, []);
  var popupCloseHandler = function popupCloseHandler() {
    var eventProps = {
      clickedOn: 'Cross',
      freeWorksheetsLeftCount: (0, _common.freeWsDownloadLeft)()
    };
    props.setShowLimitReachedPopup(false);
    if (window.parent.triggerIsFlutterHeaderClickDisabled) {
      window.parent.triggerIsFlutterHeaderClickDisabled();
    }
    _events["default"].interactedSubscribePopup(eventProps);
  };
  var onCtaClickHandler = function onCtaClickHandler() {
    var eventProps = {
      clickedOn: 'Unlock CTA',
      freeWorksheetsLeftCount: (0, _common.freeWsDownloadLeft)()
    };
    (0, _common.isFlutterUser)() ? window.parent.parent.location.href = '/dashboard#/purchase?source=printables&limit=0' : location.hash = '/purchase?source=printables&limit=0';
    _events["default"].interactedSubscribePopup(eventProps);
  };
  return /*#__PURE__*/_react["default"].createElement(S.PopupOverlay, {
    "data-sentry-element": "unknown",
    "data-sentry-component": "WSLimitReachedPopup",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.PopupWrapper, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.CrossButton, {
    onClick: popupCloseHandler,
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_crossIcon["default"], {
    "data-sentry-element": "CrossButton",
    "data-sentry-source-file": "wsLimitReached.tsx"
  })), /*#__PURE__*/_react["default"].createElement(S.PopupHeader, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, "You have no free worksheets left today"), /*#__PURE__*/_react["default"].createElement(S.PopupDetailsWrapper, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.WSImageWrapper, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.WSImage, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_wsIllustration["default"], {
    "data-sentry-element": "WSIllustration",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }), /*#__PURE__*/_react["default"].createElement("img", {
    src: props.worksheetDetails.image_url,
    alt: "worksheetImage"
  }))), /*#__PURE__*/_react["default"].createElement(S.TextWrapper, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.ListHeader, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, "Start your 7-day free trial to get:"), /*#__PURE__*/_react["default"].createElement(S.ListBody, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.ListItem, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.ListIcon, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_greenTick["default"], {
    "data-sentry-element": "GreenTick",
    "data-sentry-source-file": "wsLimitReached.tsx"
  })), /*#__PURE__*/_react["default"].createElement(S.ListText, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, "Full access to ", /*#__PURE__*/_react["default"].createElement("strong", null, "4400+ "), " Math & Reading worksheets")), /*#__PURE__*/_react["default"].createElement(S.ListItem, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.ListIcon, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_greenTick["default"], {
    "data-sentry-element": "GreenTick",
    "data-sentry-source-file": "wsLimitReached.tsx"
  })), /*#__PURE__*/_react["default"].createElement(S.ListText, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "4000+ "), " curriculum aligned games & activities")), /*#__PURE__*/_react["default"].createElement(S.ListItem, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.ListIcon, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_greenTick["default"], {
    "data-sentry-element": "GreenTick",
    "data-sentry-source-file": "wsLimitReached.tsx"
  })), /*#__PURE__*/_react["default"].createElement(S.ListText, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, "Comprehensive weekly progress reports"))))), /*#__PURE__*/_react["default"].createElement(S.CtaButton, {
    onClick: onCtaClickHandler,
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, "Start free trial for unlimited downloads"), /*#__PURE__*/_react["default"].createElement(S.FooterText, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, "You won't be charged upfront")));
};
var _default = exports["default"] = WSLimitReachedPopup;